import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export default function ModalWrapper({ children, title, onClose }) {
  return (
    <div className="fixed inset-0 bg-ink/60 backdrop-blur-[3px] flex items-center justify-center z-50 p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 20 }}
        className="bg-parchment border-2 border-parchment-dark rounded-lg w-full max-w-[540px] p-8 box-shadow-modal relative max-h-[90vh] overflow-y-auto"
      >
        <button 
          onClick={onClose}
          className="absolute top-4 right-5 bg-transparent border-none text-xl text-ink-light cursor-pointer hover:text-ink"
        >
          <SafeIcon icon={FiX} />
        </button>
        <div className="font-playfair text-2xl font-bold text-ink mb-5 pb-3 border-b border-parchment-dark">
          {title}
        </div>
        {children}
      </motion.div>
    </div>
  );
}